import { ReactNode } from "react";
import {
  ISearchDataResponse,
  ISearchItemResponseModel,
} from "../../core/models";
import Title from "../Title/Title";
import "./searchboxresult.scss";
import { Link } from "react-router-dom";
import Loading from "../Loading/Loading";

export interface SearchboxResultProps {
  searchValue: string;
  closeSearchResult: () => void;
  searchResponse?: ISearchDataResponse;
  isLoading: boolean;
}

const SearchboxResult = ({
  searchValue,
  searchResponse,
  closeSearchResult,
  isLoading,
}: SearchboxResultProps) => {
  return (
    <div className="searchbox-result">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {" "}
          {searchResponse?.mainTile && (
            <Title>{searchResponse?.mainTile}</Title>
          )}
          <ul className="searchbox-result__list">
            {searchResponse?.results.length ? (
              searchResponse.results.map(
                (item: ISearchItemResponseModel, index: number): ReactNode => {
                  return (
                    <li className="searchbox-result__list-item" key={index}>
                      <Link
                        to={{ pathname: item.url }}
                        onClick={closeSearchResult}
                      >
                        {item.type === "document" && (
                          <div className="searchbox-result-image">
                            <img
                              src={"/icons/pdf-secondary.svg"}
                              width={32}
                              height={32}
                              alt={item.pageTitle}
                              style={{ height: "auto", width: "32px" }}
                            />
                          </div>
                        )}

                        <div className="searchbox-result-text">
                          <span className="searchbox-result__list-category">
                            {item.pageTitle}
                          </span>
                          <h3 className="searchbox-result__list-title">
                            {item.slug}
                          </h3>
                        </div>
                        <span className="icon icon-arrow-right"></span>
                      </Link>
                    </li>
                  );
                }
              )
            ) : (
              <>
                <li className="searchbox-result__list-item searchbox-result__list-item--empty">
                  <img
                    src={"/icons/info.svg"}
                    width={20}
                    height={20}
                    alt={"Info"}
                  />
                  <span>{searchValue} başlığıyla ilgili sonuç bulunamadı.</span>
                </li>
                <h3 className="searchbox-result__suggestion-title">
                  Önerilen Sonuçlar
                </h3>
                {searchResponse?.popular.map(
                  (
                    item: ISearchItemResponseModel,
                    index: number
                  ): ReactNode => {
                    return (
                      <li className="searchbox-result__list-item" key={index}>
                        <Link
                          to={{ pathname: item.url }}
                          onClick={closeSearchResult}
                        >
                          <div className="searchbox-result-text">
                            <span className="searchbox-result__list-category">
                              {item.pageTitle}
                            </span>
                            <h3 className="searchbox-result__list-title">
                              {item.slug}
                            </h3>
                          </div>
                          <span className="icon icon-arrow-right"></span>
                        </Link>
                      </li>
                    );
                  }
                )}
              </>
            )}
          </ul>
        </>
      )}
    </div>
  );
};

export default SearchboxResult;
